<template>
  <div>
    <h1>Game Rules</h1>
    <h2>Objective</h2>
    <p>The player with the most money at the end of the game wins</p>

    <h2>Setup</h2>
    <ol>
      <li>Each player starts with $6,000</li>
      <li>Each player starts with 6 tiles, when one is played they will get a new tile</li>
    </ol>

    <h2>Turns</h2>
    On your turn you do the following:
    <ol>
      <li>Play a tile on the board
        <p>Resolve any hotel creations or mergers</p>
      </li>
      <li>Buy up to 3 stocks of any combination of hotels that are on the board</li>
    </ol>

    <h2>Hotel Creation</h2>
    <p>If you place a tile next to another tile that isn't part of a hotel (2 tiles by themselves), you will have the option to create a new hotel on the board. When you create a new hotel you get 1 stock for free</p>

    <h2>Hotel Mergers</h2>
    <p>If you place a tile that connects two hotels, the largest hotel acquires the smaller hotel. If they are the same size, one will be randomly selected</p>
    <p>When a merger happens, whoever owns the most stock in the company being acquired gets a majority bonus. Whoever owns second most stocks gets minority bonus.</p>
    <p>Each player, starting with the person who played the merger will have the option to 1) trade 2 stocks for 1 of the hotel staying on the board 2) Sell their stocks 3) Keep them</p>

    <h2>Game End</h2>
    <p>Game ends when you cannot build anymore hotels on the board and all hotels have been merged into one large hotel</p>

    <h2>Game End Scoring</h2>
    <p>Scoring must be done manually. Add your cash to the majority/minority bonus if you receive it. Then "sell" all stocks in that company and add it to your cash.</p>

    <h2>Majority/Minority Bonuses</h2>
    <p>If there is a tie for first, those players split majority/minority bonus and 2nd place receives nothing</p>
    <p>If there is a tie for second, those players split the minority bonus</p>
    <p>This applies anytime there is a merger or when the game has ended</p>

    <h2>Strategy Tips</h2>
    <p>Merge often, you make the most money through majority/minority bonuses</p>
    <p>Look for "merger chips" that help you control the board. This is a chip that is connected to an existing company. If someone builds a company next to that chip you will be able to control the merger. Controlling mergers is how you can plan and win.</p>
  </div>
</template>

<script>
export default {
  name: 'TheRules',
}
</script>

<style scoped>
h1 {
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 20px;
}

h2 {
  font-weight: 600;
  padding-bottom: 6px;
  padding-top: 16px;
}

ol {
  list-style: decimal;
  padding-left: 20px;
}

p, ol, li {
  line-height: 18px;
}

p {
  margin-bottom: 8px;
}
</style>
